import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { GeometryType } from "@evergis/api";
import { Positions } from "../../ducks/geometryEditor/geometryEditor";
import { useGeometryEditor } from "./useGeometryEditor";
import { FeatureDcExtended } from "../../ducks/selectFeatures/types";
import { setSelectedFeatures } from "../../ducks/selectFeatures/selectFeatures";

export const useFeatureFromGeometryEditor = (): FeatureDcExtended | undefined => {
  const [geometryEditor] = useGeometryEditor();
  const { layerName, geometry, geometryType, crs, loading } = geometryEditor;
  const dispatch = useDispatch();

  return useMemo((): FeatureDcExtended | undefined => {
    if (loading || !geometry) {
      return undefined;
    }

    const coordinates: Positions = geometry;

    if (geometryType === GeometryType.Multipoint) {
      const addedFeatures = coordinates.map((points, index) => ({
        id: index + 1,
        attributes: {},
        layer: layerName,
        geometry: {
          coordinates: points,
          sr: crs.wkid,
          type: geometryType,
        },
      }));

      dispatch(
        setSelectedFeatures({
          [layerName]: addedFeatures,
        }),
      );
    }

    return {
      layer: layerName,
      geometry: {
        coordinates,
        sr: crs.wkid,
        type: geometryType as GeometryType,
      },
      attributes: {},
    };
  }, [loading, geometry, layerName, crs.wkid, geometryType]);
};
